(function () {
    'use strict';
    app.service('storagemanagementService', ['$http', '$q', '$rootScope','$cookies',
    function ($http, $q, $rootScope, $cookies) {

        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var deviceInfo = [];
        var deferred;
       
        this.getStorageDetails = function (data) {
          
            deferred = $q.defer();
            $http.post(serviceBase + "api/super/storagedata", data, {
        }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }
        this.saveStorageDetails = function (data) {

            deferred = $q.defer();
            $http.post(serviceBase + "api/super/updateStorageCapacity?partyId=" + data.eSpectraSubmitPersonID + "&capacity=" + data.size, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.getStorageDetailsReport = function (data) {

            var searchByPremium = data.searchByPremium == true ? 2 : '-1';
            var searchByRestricted = data.searchByRestricted == true ? 1 : '-1';
            var searchByFree = data.searchByFree == true ? 0 : '-1';
            var sortDirection = data.reverse == true ? 'desc' : 'asc';
            var searchByIndividualAccount = data.searchByIndividualAccount ? '1' : '0';
            var searchByInstitutionAccount = data.searchByInstitutionAccount ? '1' : '0';
            var searchByAdministrator = data.searchByAdministrator ? '1' : '0';
            deferred = $q.defer();
            $http.get(serviceBase + "api/super/storagedatareport?searchByName=" + data.searchByName + "&searchByEmail=" + data.searchByEmail + "&searchByInstitutionName=" + data.searchByInstitutionName + "&searchByPremium=" + searchByPremium + "&searchByRestricted=" + searchByRestricted + "&searchByFree=" + searchByFree + "&sortBy=" + data.sortBy + "&reverse=" + sortDirection + "&searchByAdministrator=" + searchByAdministrator + "&searchByInstitutionAccount=" + searchByInstitutionAccount+ "&searchByIndividualAccount=" + searchByIndividualAccount, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.getinvitedUserDetail = function (data) {

            deferred = $q.defer();
            $http.get(serviceBase + "api/super/invitedUserDetails/" + data, {
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }
    }
    ]);
})();